const KPIUnavailable = () => {
  return (
    <svg
      width="169"
      height="149"
      viewBox="0 0 169 149"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M84.2455 116.844C85.018 116.844 85.6442 116.218 85.6442 115.446C85.6442 114.673 85.018 114.047 84.2455 114.047C83.4729 114.047 82.8467 114.673 82.8467 115.446C82.8467 116.218 83.4729 116.844 84.2455 116.844Z"
        fill="#CFCFCF"
      />
      <path
        d="M43.6123 11.5312V17.6687"
        stroke="#0B4EDB"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5303 14.6094H46.682"
        stroke="#0B4EDB"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M113.479 50.2415C101.533 50.2415 89.3719 49.7562 77.9961 46.5875C66.8345 43.4902 56.5864 37.4812 47.4515 30.5302C41.4711 26.0056 36.033 22.3945 28.2684 22.9369C20.6723 23.3479 13.4083 26.1845 7.54374 31.0298C-2.33329 39.6793 -0.848885 55.7081 3.10478 66.9268C9.04243 83.8691 27.1123 95.673 42.4702 103.309C60.2118 112.173 79.7089 117.325 99.2489 120.28C116.377 122.892 138.386 124.776 153.23 113.6C166.861 103.309 170.6 79.844 167.261 64.0008C166.45 59.3204 163.958 55.0973 160.252 52.1255C150.675 45.1174 136.388 49.799 125.626 50.0274C121.629 50.113 117.561 50.2129 113.479 50.2415Z"
        fill="#DDEFFD"
      />
      <path
        d="M94.1517 3.17254C94.9242 3.17254 95.5505 2.54629 95.5505 1.77377C95.5505 1.00125 94.9242 0.375 94.1517 0.375C93.3792 0.375 92.7529 1.00125 92.7529 1.77377C92.7529 2.54629 93.3792 3.17254 94.1517 3.17254Z"
        fill="#0B4EDB"
      />
      <path
        d="M21.4717 112.086V118.223"
        stroke="#0B4EDB"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4053 115.156H24.5427"
        stroke="#0B4EDB"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.8177 148.061C113.756 148.061 137.215 146.597 137.215 144.792C137.215 142.987 113.756 141.523 84.8177 141.523C55.8798 141.523 32.4209 142.987 32.4209 144.792C32.4209 146.597 55.8798 148.061 84.8177 148.061Z"
        fill="#99CFF8"
      />
      <path
        d="M126.934 109.78H36.4281C35.8224 109.779 35.2241 109.647 34.6744 109.393C34.1247 109.138 33.6369 108.768 33.2446 108.306C32.8523 107.845 32.565 107.303 32.4024 106.72C32.2399 106.136 32.206 105.525 32.3032 104.927L43.8787 34.7313C44.0351 33.7544 44.5351 32.8653 45.2887 32.2242C46.0423 31.5832 47 31.2321 47.9894 31.2344H138.496C139.101 31.2344 139.699 31.3663 140.248 31.6209C140.797 31.8754 141.284 32.2465 141.675 32.7083C142.067 33.1702 142.353 33.7117 142.513 34.2952C142.674 34.8787 142.706 35.4902 142.606 36.0873L131.088 106.283C130.928 107.266 130.421 108.159 129.659 108.8C128.897 109.442 127.93 109.789 126.934 109.78Z"
        fill="#7555D2"
      />
      <path
        d="M110.21 68.1258L56.4874 44.1396C54.9038 43.4325 53.047 44.1431 52.3399 45.7267L35.3133 83.8615C34.6063 85.4451 35.3168 87.302 36.9004 88.009L90.6229 111.995C92.2064 112.702 94.0633 111.992 94.7703 110.408L111.797 72.2733C112.504 70.6897 111.793 68.8328 110.21 68.1258Z"
        fill="white"
        stroke="#522AC7"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.535 109.75H35.586C34.4793 109.746 33.4192 109.304 32.638 108.52C31.8568 107.736 31.4182 106.674 31.4182 105.568V41.4382C31.4049 40.8819 31.5028 40.3285 31.7061 39.8104C31.9094 39.2924 32.214 38.8201 32.6022 38.4214C32.9904 38.0226 33.4542 37.7053 33.9665 37.488C34.4789 37.2708 35.0295 37.158 35.586 37.1562H68.714C69.4827 37.1591 70.2358 37.3737 70.8904 37.7766C71.5451 38.1795 72.0761 38.755 72.425 39.44L77.1494 48.689C77.4971 49.375 78.0278 49.9514 78.6827 50.3544C79.3377 50.7575 80.0914 50.9715 80.8605 50.9727H126.535C127.64 50.9727 128.7 51.4118 129.482 52.1934C130.263 52.975 130.702 54.0351 130.702 55.1404V105.568C130.702 106.674 130.264 107.736 129.483 108.52C128.701 109.304 127.641 109.746 126.535 109.75Z"
        fill="white"
        stroke="#522AC7"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M112.533 53.1563C107.279 53.1534 102.142 54.7089 97.7716 57.6259C93.4015 60.5429 89.9947 64.6904 87.9821 69.5438C85.9695 74.3971 85.4414 79.7384 86.4647 84.8919C87.488 90.0455 90.0167 94.7798 93.731 98.496C97.4452 102.212 102.178 104.743 107.331 105.77C112.484 106.796 117.826 106.27 122.68 104.26C127.535 102.25 131.684 98.8458 134.603 94.4774C137.523 90.1089 139.081 84.9728 139.081 79.7186C139.081 72.6763 136.284 65.9222 131.306 60.9412C126.328 55.9602 119.575 53.16 112.533 53.1563Z"
        fill="white"
        stroke="#522AC7"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M131.437 98.9844L138.516 106.064"
        stroke="#522AC7"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M137.714 102.621L135.515 104.922C134.529 105.953 134.566 107.588 135.597 108.574L154.684 126.821C155.715 127.807 157.351 127.77 158.337 126.738L160.536 124.438C161.522 123.406 161.485 121.771 160.454 120.785L141.367 102.539C140.335 101.553 138.7 101.59 137.714 102.621Z"
        fill="#522AC7"
      />
      <path
        d="M151.843 1.77344V7.92518"
        stroke="#0B4EDB"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M148.761 4.85938H154.912"
        stroke="#0B4EDB"
        strokeWidth="1.42732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default KPIUnavailable;
